import React, { Component } from "react";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import "react-tabs/style/react-tabs.css";
import LazyLoad from "react-lazyload";
import TagManager from 'react-gtm-module'
import axios from "axios";

import {
  getUrl,
  asyncgetWeather,
  geinstagramData,
  isMobile,
} from "../../Utility/Utility";

import {
  Img,
  HomeTitle,
  InstagremSliderItem,
  FaqItem,
  HomeSlider,
  AnimateCallToAction,
  TravelAlert,
  IconInfo,
  BoxLink,
  IsraelExpert,
} from "../../Components/UI/UI";

import { faqData } from "../../Data/Data";

import AgreeCookies from "../../Components/AgreeCookies/AgreeCookies";
import Form from "../../Components/Form/Form";

import Footer from "../../Components/Footer/Footer";
import SimpleSlider from "../../Components/SimpleSlider/SimpleSlider";
import TptTabs from "../../Components/TptTabs/TptTabs";
import TptTabsMob from "../../Components/TptTabsMob/TptTabsMob";
import "./Home.css";
import MenuHome from "../../Components/Menu/MenuHome";

// private class data

const getParam = window.location.search;
//console.log(typeof getParam);
////console.log(getParam);

class Home extends Component {
  constructor(props) {
    super(props);
    this.playVideo = this.playVideo.bind(this);
    this.playVideo2 = this.playVideo2.bind(this);
    this.playVideo3 = this.playVideo3.bind(this);
    this.playVideo4 = this.playVideo4.bind(this);
    this.state = {
      isVidClick: false,
      instagramData: [],
      instagramDataMobile: [],
      northArrMobile: [],
      // isLoading : true;
      // exporeTelAvivAndjerusalemMainVid: "5nqL-oIC0GA", old video
      // exporeTelAvivAndjerusalemMainVid: "nLKWDp5uA-U", changed at 17.05.2020
      exporeTelAvivAndjerusalemMainVid: "FYtk8JMMZRE",
      eurovisionMainVid: "5PAjhoH0NWU",
      TelAvivAndjerusalemVideoState: 0,
      culinaryVid: "jfyHxk8ZRrI",
      culinaryVidState: 0,
      faq: faqData,
      telAvivWeather: 20,
      waterTemp: 20,
      jerusalemWeather: 20,
      deadSeaWeather: 15,
      shirCssClass: " btn-shir",
      supportCssClass: " new-support-btn",
      open: false,
      instagramId: null,
      instagramUserImg: null,
      instagramCaption: null,
      instagramUserName: null,
      instagramLikes: null,
      imageState: true,
      imageState2: true,
      imageState3: true,
      imageState4: true,
      imageState5: true,
      imageState6: true,
      imageState7: true,
      imageState8: true,
      imageState9: true,
      imageState10: true,
      width: 0,
      MobileVidId1: "",
      MobileVidId1Elm: "",
      MobileVidId2: "",
      MobileVidId2Elm: "",

      MobileVidId3: "",
      MobileVidId3Elm: "",
      isInit: true,
      text1: "Travel Alert: Get the latest travel alerts impacting Israel",
      text2: " here",
      text3: "",
      coronaVirus: "/Pages/CoronaVirusPage",
      numFlights: "1800",
      numCompagny: "49",
      FlyWeekend: "300",
    };
  }

  componentWillMount() {
    this.updateDimensions();
  }
  updateDimensions = () => {
    var w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName("body")[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
    // height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

    this.setState({ width: width });
  };
  componentWillUnmount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
  }

  componentDidMount() {
    Promise.all([asyncgetWeather(), geinstagramData()]).then((response) => {
      const weather = response[0];
      const instagramData = response[1];

      this.setState({
        instagramData: instagramData.posts,
        deadSeaWeather: weather.deadsea.temperature,
        jerusalemWeather: weather.jerusalem.temperature,
        telAvivWeather: weather.telaviv.temperature,
        waterTemp: weather.telaviv.water_temp,
      });
    });

    window.setTimeout(() => {
      var hash = window.location.hash;
      console.log("hash: ", hash);
      var the_id = hash.substring(1);
      console.log("the_id: ", the_id);

      // GEt hash from URL for home page
      // var url = window.location.href;
      // alert(url);
      if (hash) {
        // Desktop variables
        var element = document.getElementById(the_id);
        var $header = document.querySelector(".menu-outer-wrapper .container2");
        var viewportOffsetHeader = $header.getBoundingClientRect();
        var $header_h = viewportOffsetHeader.height;

        // MObile variables
        var $headerMob1 = document.querySelector(
          ".menu-outer-wrapper .container-flued"
        );
        var $viewportOffsetHeaderMob1 = $headerMob1.getBoundingClientRect();
        var $header1_mob_h = $viewportOffsetHeaderMob1.height;
        var $headerMob2 = document.querySelector(
          ".menu-outer-wrapper .container2"
        );
        var $viewportOffsetHeaderMob2 = $headerMob2.getBoundingClientRect();
        var $header2_mob_h = $viewportOffsetHeaderMob2.height;
        var $headermobile_h = $header1_mob_h + $header2_mob_h;
        console.log($headermobile_h);

        // var offset = 200;
        var offset = 0;
        var viewportOffset = element.getBoundingClientRect();
        const top = viewportOffset.top;

        var newTop = top - $header_h;
        if (window.innerWidth < 1000) {
          var newTop = top - $headermobile_h;
        }
        scroll.scrollMore(newTop, {
          duration: 1500,
          delay: 50,
          smooth: true,
          offset: offset, // Scrolls to element + 50 pixels down the page
        });
      }
    }, 1000);

    axios
      .get(
        `https://data.gov.il/api/3/action/datastore_search?resource_id=e83f763b-b7d7-479e-b172-ae981ddc6de5`,
        {
          params: {
            limit: 10000,
          },
        }
      )
      .then((res) => {
        // console.log('res', res.data.result.records.length);
        // console.log('resData', res.data);
        // console.log("resResults", res.data.result.records);
        let numCompagny_ = [];
        let conter_ = 0;
        res.data.result.records.forEach((element) => {
          if (numCompagny_.indexOf(element["CHLOCCT"]) === -1) {
            numCompagny_.push(element["CHLOCCT"]);
          }
          if (this.dateCheck(element["CHPTOL"])) {
            conter_++;
          }
        });
        // console.log(res.data.result.records.length);

        this.setState({
          numFlights: res.data.result.records.length,
          numCompagny: numCompagny_.length,
          FlyWeekend: conter_,
        });
      });

    // var hash = window.location.hash;
    // //console.log('hash: ', hash);
    // var the_id = hash.substring(1);

    // if (hash) {
    //   setTimeout(() => {
    //     window.scrollTo({
    //       top: document.querySelector(hash).offsetTop - 100,
    //       left: 0,
    //       behavior: "smooth",
    //     });
    //   }, 1000);
    // }

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
  }

  dateCheck = (check) => {
    var fDate, lDate, cDate;
    fDate = new Date();
    lDate = new Date();
    lDate.setDate(lDate.getDate() + 7);
    cDate = Date.parse(check);
    var CurrentDate = new Date(check);

    if (cDate <= lDate && cDate >= fDate) {
      if (
        CurrentDate.getDay() === 5 ||
        CurrentDate.getDay() === 6 ||
        CurrentDate.getDay() === 0
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };
  openModal = (id) => {
    var url = getUrl() + "instagram-api.php?ID=" + id;

    // var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
    axios.get(url, {}).then((res) => {
      var obj = res.data;

      var userinfo = obj.graphql.shortcode_media;
      var likes = userinfo.edge_media_preview_like.count;
      var username = userinfo.owner.username;
      var caption = userinfo.edge_media_to_caption.edges[0].node.text;
      var userProfileImg = userinfo.owner.profile_pic_url;

      // console.log(username);

      this.setState({
        open: true,
        instagramId: id,
        instagramUserImg: userProfileImg,
        instagramCaption: caption,
        instagramUserName: username,
        instagramLikes: likes,
      });
    });
  };
  closeModal = () => {
    this.setState({ open: false });
  };

  handleScroll = (event) => {
    let y = window.scrollY,
      shirCssClass = "",
      supportCssClass;
    if (y > 300) {
      shirCssClass = " btn-shir show-from-left";
      supportCssClass = " new-support-btn show-from-right";
    } else {
      shirCssClass = " btn-shir";
      supportCssClass = " new-support-btn";
    }

    this.setState({
      shirCssClass: shirCssClass,
      supportCssClass: supportCssClass,
    });
  };

  //This was added for mobile youtube butn play
  playVideo = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState: false,
    });
  };
  playVideo2 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState2: false,
    });
  };
  playVideo3 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState3: false,
    });
  };
  playVideo4 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState4: false,
    });
  };
  playVideo5 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState5: false,
    });
  };
  playVideo6 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState6: false,
    });
  };
  playVideo7 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState7: false,
    });
  };

  playVideo8 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState8: false,
    });
  };

  playVideo9 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState9: false,
    });
  };

  playVideo10 = (event) => {
    // alert(this.state.imageState);
    this.setState({
      imageState10: false,
    });
  };

  closeAlert = (event) => {
    document.getElementById("travel-alert").style.display = "none";
  };
  setVideoMobile = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId1: vidId, MobileVidId1Elm: id });
  };

  setVideoMobile2 = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId2: vidId, MobileVidId2Elm: id });
  };

  setVideoMobile3 = (vidId, id) => {
    // alert('setVideoMobile : ' +   vidId);
    this.setState({ MobileVidId3: vidId, MobileVidId3Elm: id });
  };

  setVideo = (vidId, ctg) => {
    // alert("ss");
    if (
      ctg === "culinary" ||
      ctg === "culinarytelaviv" ||
      ctg === "culinaryjerusalem" ||
      ctg === "culinarynorth"
    ) {
      this.setState({ culinaryVid: vidId });
      const e = document.getElementById("CULINARY");

      scroll.scrollTo(e.offsetTop - 100);

      if (isMobile) {
        this.setState({
          imageState7: false,
        });
      }
    } else {
      const elm = document.getElementById("expore-tel-aviv-and-jerusalem");

      scroll.scrollTo(elm.offsetTop - 100);
      this.setState({ exporeTelAvivAndjerusalemMainVid: vidId });

      if (isMobile) {
        this.setState({
          imageState8: false,
        });
      }
    }
  };

  setCurrentFaq = (id) => {
    const faq = [...this.state.faq];
    const current = faq.find((o) => {
      return o.id === id;
    });
    if (current.isOpen === true) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      faq: faq,
    });
  };

  handleisVidClick = () => {
    this.setState({
      isVidClick: !this.state.isVidClick,
    });
  };

  render() {
    const sliderSettings = {
      dots: true,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "linear",
      slidesToShow: this.props.items != undefined ? this.props.items : 1,
      slidesToScroll: 1,
      arrows: false,
      cssEase: "ease-in-out",
      autoplaySpeed: 4000,
      speed: 2200,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const sliderSettings2 = {
      dots: false,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "ease-in-out",
      autoplaySpeed: 2000,
      speed: 2200,
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const sliderSettings3 = {
      dots: false,
      autoplay: true,
      // lazyLoad: 'ondemand',
      infinite: true,
      lazyLoad: "ondemand",
      cssEase: "ease-in-out",
      autoplaySpeed: 2000,
      speed: 2200,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };

    let tipsHTML = (
      <SimpleSlider settings={sliderSettings}>
        <div>
          <h5 className="sliderTips">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley
          </h5>
          <br />
          <p className="ac-name">Rotem</p>
        </div>
        <div>
          <h5 className="sliderTips">
            Contrary to popular belief, Lorem Ipsum is not simply random text.
            It has roots in a piece of classical Latin literature from 45 BC,
            making it over 2000 years old. Richard McClintock, a Latin professor
            at Hampden-Sydney College in Virginia, looked
          </h5>
          <br />
          <p className="ac-name">Mike</p>
        </div>
        <div>
          <h5 className="sliderTips">
            There are many variations of passages of Lorem Ipsum available, but
            the majority have suffered alteration in some form, by injected
            humour, or randomised words which don't look even slightly
            believable.
          </h5>
          <br />
          <p className="ac-name">Niki</p>
        </div>
        <div>
          <h5 className="sliderTips">
            em Ipsum is that it has a more-or-less normal distribution of
            letters, as opposed to using 'Content here, content here', making it
            look like readable English. Many desktop publishing packages and web
            page editors
          </h5>
          <br />
          <p className="ac-name">Shimon</p>
        </div>
      </SimpleSlider>
    );

    const faqHtml = this.state.faq.map((o) => {
      return (
        <FaqItem
          q={o.q}
          key={o.id}
          answer={o.answer}
          isOpen={o.isOpen}
          click={() => {
            this.setCurrentFaq(o.id);
            TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'faq_click','element_location':'faq', 'click_cta':o.q,}});
          }}
        />
      );
    });
    let instagramHtml = null;
    let callToActionHtml = "";

    // if (this.state.width > 1000) {
    callToActionHtml = (
      <div>
        <AnimateCallToAction
          src={"btn_shir_desk1.png"}
          srcMob={"btn_shir_mob.png"}
          cssClass={this.state.shirCssClass}
          link={"#"}
        />
        {/*<AnimateCallToAction  src={"support.png"}  cssClass={this.state.supportCssClass} link={"https://virtual.goisrael.com/"} />*/}
      </div>
    );
    // }

    var instagramData = this.state.instagramData;
    // console.log('instagramData: ' , instagramData);

    var insta_size = 1;
    // if ( this.state.width < 1000 ) {
    //     size = 4;
    // }
    if (this.state.width < 600) {
      // insta_size = 4;
      insta_size = 1;
    }
    if (instagramData.length > 0) {
      while (instagramData.length > 0) {
        this.state.instagramDataMobile.push(
          instagramData.splice(0, insta_size)
        );
      }
    }

    if (this.state.instagramDataMobile.length > 0) {
      instagramHtml = this.state.instagramDataMobile.map((arr, i) => {
        return arr.map((o, i) => {
          var imgLink = "instagram/" + o.id + ".jpg";

          if (this.state.width < 600) {
            imgLink = "instagram/Mobile/" + o.id + ".jpg";
          }
          return (
            <div
              key={o.publishBy}
              onClick={() => {
                this.openModal(o.id);
              }}
            >
              {" "}
              <InstagremSliderItem
                title={o.publishBy}
                cssClass={"InstagremSliderItem-" + i}
                img={imgLink}
              />
            </div>
          );
        });
      });
      // console.log('instagramHtml2' , instagramHtml2);
      instagramHtml = instagramHtml.map((o, i) => {
        // console.log(o);
        return <div>{o}</div>;
      });
    }

    const currentInstagramLikeUrl =
      "https://www.instagram.com/p/" + this.state.instagramId + "/";
    const currentInstagramUrl =
      "https://www.instagram.com/" + this.state.instagramUserName + "/";
    const currentInstagramImgUrl =
      "instagram/" + this.state.instagramId + ".jpg";

    let a = (
      <div>
        <HomeSlider
          isHomeSlider={true}
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
          // textH={"TRAVEL AGENT’S GUIDE \nSTART PLANNING"}
        />
      </div>
    );

    let SliderMobile = (
      <SimpleSlider settings={sliderSettings3}>
        <div>
          <IconInfo
            href={
              "https://www.iaa.gov.il/en/airports/ben-gurion/airline-companies/"
            }
            wrapperCss="2"
            img={"Home/iconinfo/airlines.svg"}
            title={"AIRLINES"}
            num={this.state.numCompagny}
          />
        </div>
        <div>
          <IconInfo
            href={"https://www.iaa.gov.il/en"}
            wrapperCss="3"
            img={"Home/iconinfo/airports.svg"}
            title={"AIRPORTS"}
            num={this.state.FlyWeekend}
          />
        </div>
        <div>
          <IconInfo
            href={
              "https://www.iaa.gov.il/en/airports/ben-gurion/flight-board/?flightType=arrivals"
            }
            wrapperCss="1"
            img={"Home/iconinfo/landingboards.svg"}
            title={"FLIGHT BOARD"}
            num={this.state.numFlights}
          />
        </div>
      </SimpleSlider>
    );

    return (
      <div className="page align-center page-home">
        {callToActionHtml}
        <MenuHome />
        <TravelAlert
          toLink={this.state.coronaVirus}
          click={this.closeAlert}
          placeText1={this.state.text1}
          placeText2={this.state.text2}
          placeText3={this.state.text3}
        />
        {a}

        {/* <ParalaxBg
          titleRowOne={'TEXT HEADLINE'}
          titleRowTwo={'COOL WELCOME'}
          id={'home-main-paralax'}
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL +
              '/assets/img/HomeSlider/desktop/uk/1.jpg'})`,
          }}
          id={'home-main-paralax'}
        />*/}

        <section
          className="home-section home-section-padding ac-icon-info"
          id="icon-info"
        >
          <div className="container">
            <div className="clear"></div>
            {SliderMobile}
          </div>
        </section>

        <section
          className="home-section home-section-padding ac-chose-interest"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL +
              "/assets/img/chose-interestbg.jpg"})`,
          }}
          id="chose-interest"
        >
          <div className="container">
            <div className="ac-inner-container">
              <BoxLink
                isRecomItine={false}
                link={"#"}
                isImgLink={false}
                wrapperCss={"1"}
                mainTitle={"CHOOSE YOUR \n INTEREST"}
                text={
                  "Want to tailor the best vacation for your clients? Choose the relevnt interest box and lets begin"
                }
              />
              <BoxLink
                isRecomItine={false}
                link={"/Pages/InterestsGeneral"}
                isImgLink={true}
                wrapperCss={"2"}
                img={"Home/boxlink1/1.jpg"}
                imgMob={"Home/boxlink1/1mob.jpg"}
                title={"GENERAL"}
                imgArrowBlack={"arrowbright.svg"}
                imgArrowWhite={"arrowwright.svg"}
              />
              <BoxLink
                isRecomItine={false}
                link={"/Pages/InterestsMice"}
                isImgLink={true}
                wrapperCss={"4"}
                img={"Home/boxlink1/3.png"}
                title={"MICE"}
                imgArrowBlack={"arrowbright.svg"}
                imgArrowWhite={"arrowwright.svg"}
              />
              <BoxLink
                isRecomItine={false}
                link={"/Pages/InterestsJewish"}
                isImgLink={true}
                wrapperCss={"3"}
                img={"Home/boxlink1/2.jpg"}
                title={"JEWISH"}
                imgArrowBlack={"arrowbright.svg"}
                imgArrowWhite={"arrowwright.svg"}
              />

              <BoxLink
                isRecomItine={false}
                link={"/Pages/InterestsChristian"}
                isImgLink={true}
                wrapperCss={"4"}
                img={"Home/boxlink1/4.jpg"}
                title={"CHRISTIAN"}
                imgArrowBlack={"arrowbright.svg"}
                imgArrowWhite={"arrowwright.svg"}
              />
            </div>
          </div>
        </section>
        <LazyLoad height={200} once offset={50}>
          <section
            className="home-section home-section-padding ac-israel-expert"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL +
                "/assets/img/Interests/israel-expert.jpg"})`,
            }}
            id="israel-expert"
          >
            <div className="container">
              <IsraelExpert />
            </div>
          </section>
        </LazyLoad>
        <section
          className="home-section home-section-padding ac-travel-planning"
          id="travel-planning"
        >
          <div className="container">
            <HomeTitle cssClass="ac-black">
              TRAVEL <br className="ac-show-on-cell" />
              PLANNING TOOLS <br />
            </HomeTitle>
            {/* <small className="ac-sub-maintitle">
              I would like to have some text please.
            </small> */}
            <div className="ac-inner-container">
              <TptTabs />
              <TptTabsMob />
            </div>
          </div>
        </section>
        <section className="home-section home-section-padding" id="form">
          <div className="container">
            <div className="ac-outter-col ac-outter-col-1">
              <HomeTitle>
                <strong>SIGN UP HERE FOR UPDATES</strong>
                <br />
                <span className="ac-spanfor-mob">
                  FROM THE <br className="ac-show-on-cell" />
                  ISRAEL MINISTRY
                  <br className="ac-show-on-cell" /> OF TOURISM
                </span>
              </HomeTitle>
              <Form />
            </div>
            <div className="ac-outter-col ac-outter-col-2">
              <Img
                desktopImg="NEWSLETTER-ICONS.svg"
                mobileImg="NEWSLETTER-ICONS.svg"
              />
            </div>
          </div>
        </section>

        <section
          className="home-section home-section-padding"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL +
              "/assets/img/chose-interestbg.jpg"})`,
          }}
          id="faq"
        >
          <div className="container">
            <HomeTitle>
              <Link to={"/Pages/FAQ"} className="ac-faq">
                FAQ
              </Link>
            </HomeTitle>
            <div className="clear"></div>

            <div className="faq-wrapper">
              <div className="ac-col-faq ac-col-faq-1">{faqHtml}</div>
              <div className="ac-col-faq ac-col-faq-2">{faqHtml}</div>
            </div>
            <div className="clear"></div>
          </div>
        </section>

        {/* This Section hided because of missing the content */}
        {/* <section
          className="home-section home-section-padding ac-tips"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL +
              "/assets/img/bgpost.jpg"})`,
          }}
          id="tips"
        >
          <div className="container">
            <div className="ac-inner-container">
              <HomeTitle>
                TRAVEL
                <br className="ac-on-show-cell" /> AGENTS' TIPS
              </HomeTitle>
              <div className="clear"></div>
              {tipsHTML}
            </div>
          </div>
        </section> */}

        <Footer />

        <AgreeCookies />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Pages/Home/Home.js